/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import ReactApexChart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { useTheme } from 'styled-components'

interface Props {
  title: string
  type: 'alto' | 'baixo'
  data: { name: string; giroMedio: number }[]
}

export const RankSubChart: React.FC<Props> = ({ title, type, data = [] }) => {
  const theme = useTheme() as any
  const isLight = theme?.name === 'light'
  const isAlto = type === 'alto'
  const mainColor = isAlto ? (isLight ? '#15803d' : '#a6c10b') : '#ef4444'

  const series = [
    {
      name: 'Giro Médio (cx/dia)',
      data: data.map((i) => Number(Number(i.giroMedio || 0).toFixed(2))),
    },
  ]

  const categories = data.map((i) => i.name || '-')

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      animations: { enabled: true, speed: 350 },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 3,
        barHeight: '70%',
      },
    },
    colors: [mainColor],
    xaxis: {
      categories,
      labels: {
        style: { colors: isLight ? '#64748b' : '#94a3b8', fontSize: '10px' },
        formatter: (val) => Number(val).toFixed(1),
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: { colors: isLight ? '#0f172a' : '#ffffff', fontSize: '10px', fontWeight: 500 },
        maxWidth: 115,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => Number(val).toFixed(2),
      style: { fontSize: '10px', colors: [isLight ? '#0f172a' : '#ffffff'], fontWeight: 600 },
      offsetX: 10,
    },
    grid: {
      borderColor: isLight ? '#e2e8f0' : 'rgba(255, 255, 255, 0.07)',
      xaxis: { lines: { show: true } },
      yaxis: { lines: { show: false } },
      padding: { top: 0, right: 15, bottom: 0, left: 5 },
    },
    tooltip: {
      theme: isLight ? 'light' : 'dark',
      y: {
        formatter: (val: number) => `${Number(val).toFixed(2)} cx/dia`,
      },
    },
    noData: {
      text: 'Sem dados no período',
      style: { color: isLight ? '#64748b' : '#94a3b8', fontSize: '12px' },
    },
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      <div
        style={{
          textAlign: 'center',
          fontSize: '11px',
          fontWeight: 700,
          color: mainColor,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          marginBottom: '4px',
          paddingBottom: '4px',
          borderBottom: isLight ? '1px solid #e2e8f0' : '1px solid rgba(255, 255, 255, 0.05)',
        }}
      >
        {isAlto ? '🟢' : '🔴'} {title}
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <ReactApexChart options={options} series={series} type='bar' height='100%' />
      </div>
    </div>
  )
}
